export enum contractorType{
    SubContractor = 'Sub Contractor',
    ThirdParty = 'Third Party'
}